const s = {
  name: "TrashBin",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,31V15h2v16H11z"/>
		<path class="st0" d="M19,15v16h2V15H19z"/>
		<path class="st0" d="M22.7,6l-1.3-3.9l0,0C21,0.8,19.8,0,18.6,0h-5.1c-1.3,0-2.4,0.8-2.8,2.1l0,0L9.3,6H0v2h3.1l1.8,29.2l0,0
			C5,38.8,6.3,40,7.9,40h16.2c1.6,0,2.9-1.2,3-2.8l0,0L28.9,8H32V6H22.7z M13.4,2h5.1c0.4,0,0.8,0.3,1,0.7l0,0L20.6,6h-9.2l1.1-3.3
			l0,0C12.6,2.3,13,2,13.4,2z M26.9,8l-1.8,29.1l0,0c0,0.5-0.5,0.9-1,0.9H7.9c-0.5,0-1-0.4-1-0.9l0,0L5.1,8H26.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as TrashBin
};
